

// Product JS for product forms

export class ProductForm {

    constructor(form, json) {

        this.form = form;
        this.json = json;
        this.master_select = this.form.querySelector('select.product-master-selector');

        this.selectors = {
            radioOption: 'radio-option',
            singleOptionSelector: 'single-option-selector',
            quantityContainer: 'quantity-selector',
            quantityInput: 'quantity-input',
            quantityPlus: 'quantity-plus',
            quantityMinus: 'quantity-minus',
            addToCart: 'add-to-cart',
            soldOut: 'sold-out',
            priceContainer: 'product-price',
            optionContainer: 'product-option-wrapper',
            optionHeadingContainer: 'option-heading-wrapper',
            optionHeadingName: 'option-name',
            optionRadios: 'option-radios',
            productSwatches: 'product-swatches',
            productSwatchName: 'swatch-name',
            productSwatch: 'swatch',
            stockIndicator: 'stock-indicator',
            PreOrderController: 'pre-order-controller',
        }

        this.init();
    }



    init () {
        // console.log('🚀🚀🚀 Product Form initialised...', this.form, ' JSON: ', this.json);
        this.form.addEventListener('click', this.handleClickEvents.bind(this));
        this.form.addEventListener('change', this.handleChangeEvents.bind(this));

        this.selectedVariantOnLoad();
        this.initMasterSelectCallback();

        // Disable Sold Out variants
        this.disableSoldOutRadios();

        this.handleSwatches();

        if (!this.selected_variant) {
            // Ensure initial state (no variant selected) does NOT show BIS
            this.updateAddToCartStatus(null);
            return;
        }

        this.resetQuantity(this.selected_variant.id);
        this.checkVariantAvailability(this.selected_variant.id);
        this.updateVariantInfo(this.selected_variant.id);
        this.updateOptionHeadings();
    }



    handleClickEvents (e) {
        // console.log('Click! ', e.target);
        this.optionRadios(e);
        this.quantityControls(e);
        this.handleAddToCart(e);
    }


    handleChangeEvents (e) {
        const select = e.target;
        if (!select.classList.contains('single-option-selector')) {
            return;
        } else {
            this.optionSelects(e);

        }
    }



    handleAddToCart (e) {
        if (e.target.classList.contains(this.selectors.addToCart)) {
            e.preventDefault();
            const addToCart = e.target;

            const variant_id = this.master_select.value;
            const quantityInput = this.form.querySelector(`.${this.selectors.quantityContainer} .${this.selectors.quantityInput}`);
            const quantity = quantityInput.value;

            const preorderInput = this.form.querySelector('input[name="properties[_pre_order_item]"]');
            let properties = {};

            if (preorderInput) {
                properties['_pre_order_item'] = preorderInput.value;
            }

            let formData = {
                'items': [{
                    'id': variant_id,
                    'quantity': quantity,
                    'properties': properties
                }]
            };
            console.log('Add to Cart Clicked! ', addToCart, ' formData: ', formData);

            // Add to cart
            window.Cart.add(formData);

            const event = new CustomEvent('PUSH_CART: ITEM_ADDED');
            window.dispatchEvent(event);
        }
    }


    updateURLVariantParameters (variant_id) {
        if (!this.form.classList.contains('product-card-form')) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            const key = 'variant';

            if (params.has(key)) params.set(key, variant_id);
            else params.append(key, variant_id);

            url.search = params.toString();
            window.history.replaceState({}, '', url);

        }
    }



    selectedVariantOnLoad () {
        /*
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString)
        const variantURL = urlParams.get('variant');
        */

        // console.log( 'variantURL: ', variantURL )

        let selected_variant_id = this.master_select.value;

        // Auto-select if product has only one variant
        if (!selected_variant_id && this.json.variants.length === 1) {
            selected_variant_id = this.json.variants[0].id;
            this.master_select.value = selected_variant_id;
        }

        if (!selected_variant_id) return

        this.selected_variant = this.json.variants.find(variant => variant.id == selected_variant_id);
        // Default to First Variant if sold out
        // if ( !selected_or_first_available && everyVariantSoldOut ) selected_or_first_available = this.json.variants[0];

        /*

        if (variantURL != null && this.json.variants.find(variant => variant.id == variantURL) ) {
            selected_or_first_available = this.json.variants.find(variant => variant.id == variantURL);

        } else if ( !everyVariantSoldOut ) {
            selected_or_first_available = this.json.variants.find(variant => variant.available === true);
        } else {
            selected_or_first_available = this.json.variants[0];
        }
        */

        // console.log('selected_or_first_available', selected_or_first_available);
        // this.master_select.value = selected_or_first_available.id;

        // THEN Select Variant Option Radios + Selects programatically
        const options = this.selected_variant.options;
        options.forEach((option, index) => {
            const optionPosition = index + 1;
            // console.log( 'option: ', option, '  | optionPosition: ', optionPosition );

            // Select Option Radio
            const optionRadio = this.form.querySelector(`.${this.selectors.optionRadios}[data-option-position="${optionPosition}"] .${this.selectors.radioOption}[value="${option}"]`);
            if (optionRadio) {
                // console.log( 'optionRadio: ', optionRadio );
                optionRadio.checked = true;
            }

            // Select Option Select
            const optionSelect = this.form.querySelector(`select.${this.selectors.singleOptionSelector}[data-option-position="${optionPosition}"]`);
            if (optionSelect) {
                // console.log('optionSelect onLoad: ', optionSelect);
                optionSelect.value = option;
            }


        });

        this.updateURLVariantParameters(this.selected_variant.id);
        this.checkVariantAvailability(this.selected_variant.id);
    }



    initMasterSelectCallback () {
        this.master_select.addEventListener('change', () => {
            const selected_variant = this.json.variants.find(variant => variant.id == this.master_select.value);
            const variant_id = selected_variant.id;

            // Update Selected Variant Variable
            if (selected_variant) this.selected_variant = selected_variant;
            else this.selected_variant = null;

            // console.log( '🚀🚀🚀 Master Select Updated... | selected variant: ', this.selected_variant );

            // Update URL Parmaters
            this.updateURLVariantParameters(variant_id);

            this.resetQuantity(variant_id);
            this.checkVariantAvailability(variant_id);
            this.updateVariantInfo(variant_id);
            this.updateOptionHeadings();
        });
    }



    checkVariantAvailability (variant_id) {
        // const selected_variant = this.json.variants.find( variant => variant.id == variant_id );
        // console.log('🚀 Checking Availability... ', selected_variant.available, ' | variant_id: ', variant_id );

        this.updateAddToCartStatus(this.selected_variant);

        let availability;
        if (this.selected_variant) availability = this.selected_variant.available;
        else availability = false;
    }


    updateAddToCartStatus (variant) {
        const addToCart = this.form.querySelector(`.${this.selectors.addToCart}`);
        const addToCartText = this.form.getAttribute('data-add-to-cart');
        const soldOutText = this.form.getAttribute('data-sold-out');
        const unavailableText = this.form.getAttribute('data-unavailable');
        const preOrderController = this.form.querySelector(`.${this.selectors.PreOrderController}`);
        const preOrderCartConflict = preOrderController?.getAttribute('data-pre-order-cart-conflict') === 'true';
        const variantHasBeenSelected = !!new URLSearchParams(document.location.search).get("variant")
        const hasUserSelection = this.form.querySelectorAll(`.${this.selectors.optionContainer} input.${this.selectors.radioOption}:checked`).length > 0;
        const bisTriggers = document.querySelectorAll('.klaviyo-bis-trigger');

        // Helper to hide all BIS buttons safely
        const hideBis = () => {
            bisTriggers.forEach((trigger) => {
                trigger.classList.remove('bis-visible');
            });
        };

        // Helper to show all BIS buttons safely
        const showBis = () => {
            bisTriggers.forEach((trigger) => {
                trigger.classList.add('bis-visible');
            });
        };

        if (variant) {
            const availability = variant.available;

            // For multi-variant products, do not show "unavailable"/BIS
            // until a user has actually selected a specific option.
            if (this.json.variants.length > 1 && !hasUserSelection) {
                addToCart.disabled = true;
                addToCart.classList.remove('unavailable');
                addToCart.querySelector('.text').innerHTML = addToCartText;
                hideBis();
                return;
            }

            if (preOrderCartConflict && variantHasBeenSelected) {
                addToCart.disabled = true;
                addToCart.classList.remove('unavailable');
                addToCart.querySelector('.text').innerHTML = addToCartText;
                hideBis();
            } else if (availability === true) {
                addToCart.removeAttribute('disabled');
                addToCart.classList.remove('unavailable');
                addToCart.querySelector('.text').innerHTML = addToCartText;
                hideBis();
            } else {
                addToCart.disabled = true;
                addToCart.classList.add('unavailable');
                addToCart.querySelector('.text').innerHTML = soldOutText;
                showBis();
            }
        } else {
            // No variant selected yet (or product unavailable without variants)
            addToCart.disabled = true;
            addToCart.classList.remove('unavailable');
            addToCart.querySelector('.text').innerHTML = unavailableText;
            hideBis();
        }
    }


    updateOptionHeadings () {
        const selected_radios = this.form.querySelectorAll(`.${this.selectors.optionContainer} input.${this.selectors.radioOption}:checked`);

        if (selected_radios) {
            selected_radios.forEach(selected_radio => {
                const radio_value = selected_radio.value;
                const radio_formatted_value = selected_radio.getAttribute('data-formatted-value');
                const option_heading = selected_radio.closest(`.${this.selectors.optionContainer}`).querySelector(`.${this.selectors.optionHeadingContainer}`);
                if (option_heading) {
                    const option_heading_name = option_heading.querySelector(`.${this.selectors.optionHeadingName}`);

                    if (option_heading_name) {
                        if (radio_formatted_value) option_heading_name.innerHTML = radio_formatted_value;
                        else if (radio_value) option_heading_name.innerHTML = radio_value;
                        else option_heading_name.innerHTML = '';

                    }
                }

            });
        }


        // Update Select Headings
        const selected_selects = this.form.querySelectorAll(`.${this.selectors.singleOptionSelector}`);
        if (selected_selects) {

            selected_selects.forEach(select => {
                const selected_option = select.options[select.selectedIndex];

                const option_value = selected_option.value;
                const option_formatted_value = selected_option.getAttribute('data-formatted-value');
                const option_heading = select.closest(`.${this.selectors.optionContainer}`).querySelector(`.${this.selectors.optionHeadingContainer}`);
                if (option_heading) {
                    const option_heading_name = option_heading.querySelector(`.${this.selectors.optionHeadingName}`);
                    if (option_heading_name) {
                        if (option_formatted_value && option_heading_name.innerHTML != option_formatted_value) option_heading_name.innerHTML = option_formatted_value;
                        else if (option_value && option_heading_name.innerHTML != option_value) option_heading_name.innerHTML = option_value;
                        else option_heading_name.innerHTML = '';
                    }
                }

            });

        }

    }


    optionRadios (e) {
        const target = e.target;

        if (target.classList.contains(this.selectors.radioOption)) {
            const radioOptionPosition = target.getAttribute('data-option-position');

            // Check if Single Option Select Exists
            const singleOptionSelect = this.form.querySelector(`select.${this.selectors.singleOptionSelector}[data-option-position="${radioOptionPosition}"]`);

            if (singleOptionSelect) {
                // console.log('singleOptionSelect: ', singleOptionSelect);
                singleOptionSelect.value = target.value;
            }

            // Update Master Select
            const selected_variant = this.findVariantFromOptions();

            if (selected_variant) this.master_select.value = selected_variant.id;
            else this.master_select.value = '';

            this.master_select.dispatchEvent(new Event('change'));
            window.dispatchEvent(new CustomEvent('variant:Changed'))
        }
    }


    optionSelects (e) {
        const select = e.target;

        // console.log('Single Option Selector Changed!', select );
        const selectOptionPosition = select.getAttribute('data-option-position');

        // Check if Radio with Same Value Exists
        const optionRadios = this.form.querySelectorAll(`input.${this.selectors.radioOption}[data-option-position="${selectOptionPosition}"]`);
        if (optionRadios) {
            optionRadios.forEach(optionRadio => {
                if (optionRadio.value == select.value) {
                    optionRadio.checked = true;
                    // console.log('Found Selects Radio!');
                } else {
                    optionRadio.checked = false;
                }
            });
        }

        // Update Master Select
        const selected_variant = this.findVariantFromOptions();
        if (selected_variant) this.master_select.value = selected_variant.id;
        else this.master_select.value = '';
        // console.log('🐷 selected_variant', selected_variant, ' |  🐷 Master value: ', this.master_select.value );

        this.master_select.dispatchEvent(new Event('change'));
    }



    findVariantFromOptions () {
        const variants = this.json.variants;
        const selected_options = this.form.querySelectorAll(`input:checked.${this.selectors.radioOption}, select.${this.selectors.singleOptionSelector}`);
        const selected_options_arr = [...new Set(Array.from(selected_options).map(option => option.value))];

        const arrayValuesMatch = (a, b) => JSON.stringify(a.sort()) === JSON.stringify(b.sort());

        let matched_variant = null;

        variants.forEach(variant => {

            if (arrayValuesMatch(selected_options_arr, variant.options)) {
                // console.log('Found a match!', variant)
                matched_variant = variant;
                return
            }
        });

        return matched_variant;

    }



    quantityControls (e) {
        const target = e.target;
        const quantityContainer = target.closest(`.${this.selectors.quantityContainer}`)
        if (quantityContainer) {
            const quantity_input = quantityContainer.querySelector(`.${this.selectors.quantityInput}`);
            let quantity = parseInt(quantity_input.value);
            const min = quantity_input.min;
            const max = quantity_input.max ? quantity_input.max : 99999;
            let new_value;

            if (target.classList.contains(this.selectors.quantityMinus)) new_value = quantity - 1;
            else if (target.classList.contains(this.selectors.quantityPlus)) new_value = quantity + 1;

            if (new_value > 0 && new_value <= max) {
                quantity_input.value = new_value;
                // console.log('🧨🧨🧨 quantity updated... ', `min: ${min} | max: ${max} | new_value: ${new_value}` );

                if (new_value == min) quantityContainer.classList.add('min-reached');
                else quantityContainer.classList.remove('min-reached');

                if (new_value == max) quantityContainer.classList.add('max-reached');
                else quantityContainer.classList.remove('max-reached');
            }
        }
    }


    resetQuantity () {
        const quantityContainer = this.form.querySelector(`.${this.selectors.quantityContainer}`);
        const quantityInput = quantityContainer.querySelector(`.${this.selectors.quantityInput}`);
        const stockIndicator = this.form.querySelector(`.${this.selectors.stockIndicator}`);

        if (quantityContainer && quantityInput) {
            const variant = this.selected_variant;
            const inventory_quantity = variant.inventory_quantity;
            const inventory_management = variant.inventory_management;

            if (inventory_quantity <= 0 && inventory_management != null) {
                quantityInput.value = 0;
                quantityInput.max = 0;
                quantityContainer.classList.add('disabled');

                quantityContainer.classList.remove('min-reached', 'max-reached');
                quantityContainer.classList.add('out-of-stock');

                if (stockIndicator) stockIndicator.innerHTML = '';

            } else {
                quantityInput.value = 1;
                quantityInput.max = inventory_quantity > 0 ? inventory_quantity : 9999;
                quantityContainer.classList.remove('disabled');


                quantityContainer.classList.remove('out-of-stock');

                if (quantityInput.min == quantityInput.value) quantityContainer.classList.add('min-reached');
                else quantityContainer.classList.remove('min-reached');

                if (quantityInput.max == quantityInput.value) quantityContainer.classList.add('max-reached');
                else quantityContainer.classList.remove('max-reached');


                // Stock Indicator
                if (stockIndicator) {
                    if (quantityInput.max <= 10) stockIndicator.innerHTML = `Only ${quantityInput.max} left in stock!`;
                    else stockIndicator.innerHTML = '';
                }
            }

            // console.log('inventory quantity: ', inventory_quantity)
        }
    }



    // Update Variant Information
    // Update Variant Information
    updateVariantInfo () {
        // const selected_variant = this.json.variants.find( variant => variant.id == variant_id );

        const priceContainer = this.form.querySelector(`.${this.selectors.priceContainer}`);
        const price_html = generatePriceHTML(this.selected_variant);

        if (priceContainer) priceContainer.innerHTML = price_html;

        // Format Money Helper
        function formatMoney (amount) {
            /*
            let price = (amount / 100).toFixed(2);
            return currency + price;
            */
            const format = Shopify.money_format;
            return Shopify.formatMoney(amount, format)
        }

        // Generate HTML for Variant Price
        function generatePriceHTML (variant) {
            const price = variant.price;
            const compare_at_price = variant.compare_at_price;
            let html;

            // console.log('price: ', price, ' compare_at_price: ', compare_at_price )

            if (!price) {
                priceContainer.style.display = 'none';

            } else {
                priceContainer.style.display = 'block';

                if (compare_at_price > price) {
                    // Is on Sale
                    html = `
                        <span class="sale-price">${formatMoney(compare_at_price)}</span>
                        <span class="price">${formatMoney(price)}</span>
                    `;

                } else {
                    html = `<span class="price">${formatMoney(price)}</span>`;
                }

            }

            return html;
        }

    }


    // Disable Radios that have NO variant available with that option
    disableSoldOutRadios () {
        const all_variants = this.json.variants;
        const radioOptionContainers = this.form.querySelectorAll(`.${this.selectors.optionRadios}`);
        // console.log('all variants: ', all_variants);

        if (radioOptionContainers) {

            radioOptionContainers.forEach(radioOptionContainer => {
                const optionPosition = radioOptionContainer.getAttribute('data-option-position');
                const optionVar = `option${optionPosition}`;
                const optionRadios = radioOptionContainer.querySelectorAll(`.${this.selectors.radioOption}`);


                optionRadios.forEach(optionRadio => {
                    const optionVariants = all_variants.filter(variant => variant[optionVar] == optionRadio.value);
                    const areAllUnavailable = optionVariants.every(variant => variant.available === false);
                    // console.log('optionRadio: ', optionRadio.value, ' | optionVariants: ', optionVariants, ' | areAllUnavailable: ', areAllUnavailable );

                    // No Variants with Option Available
                    if (areAllUnavailable == true) {
                        optionRadio.classList.add('unavailable');
                    }

                })

            });
        }
    }


    /*
    // Disable Radios that aren't available with the current Selection
    disableUnavailableRadios() {
        const all_variants = this.json.variants;
        const radioOptionContainers = this.form.querySelectorAll(`.${ this.selectors.optionRadios }`);

        const selectedRadios = this.form.querySelectorAll(`.${ this.selectors.radioOption }:checked`);


        selectedRadios.forEach( selectedRadio => {
            const currentOptionPosition = selectedRadio.getAttribute('data-option-position');
            const currentSelectedValue = selectedRadio.value;

            console.log('checking....', selectedRadios );

            radioOptionContainers.forEach( optionContainer => {
                const containerOptionPosition = optionContainer.getAttribute('data-option-position');

                console.log('optionContainer: ', optionContainer);

                if ( containerOptionPosition != currentOptionPosition ) {

                    const radioOptions = optionContainer.querySelectorAll(`.${ this.selectors.radioOption }`);

                    radioOptions.forEach( radioOption => {
                        const currentValue = radioOption.value;

                        const variantsWithBothValues = all_variants.filter( variant => variant[ `option${ currentOptionPosition }` ] == currentSelectedValue && variant[ `option${ containerOptionPosition }` ] == currentValue );
                        console.log('selected Value: ', currentSelectedValue, ' | current value: ', currentValue , ' | variantsWithBothValues: ', variantsWithBothValues)

                    });

                }

            })


        });

    }
    */



    handleSwatches () {
        const swatchContainer = this.form.querySelector(`.${this.selectors.productSwatches}`);

        // console.log('swatchContainer: ', swatchContainer);

        if (swatchContainer) {
            const swatches = swatchContainer.querySelectorAll(`.${this.selectors.productSwatch}`);
            const swatchNameHeading = swatchContainer.querySelector(`.${this.selectors.productSwatchName}`);

            if (swatchNameHeading) {
                const currentSwatchName = swatchNameHeading.getAttribute('data-swatch-name');

                if (swatches && swatchNameHeading) {

                    swatches.forEach(swatch => {

                        swatch.addEventListener('mouseover', () => {
                            const swatchName = swatch.getAttribute('data-swatch-name');
                            swatchNameHeading.innerHTML = swatchName;
                        });

                        swatch.addEventListener('mouseout', () => {
                            swatchNameHeading.innerHTML = currentSwatchName;
                        });
                    });

                }

            }

        }

    }

}

// window.ProductForm = ProductForm;


// Product Card Events
document.body.addEventListener('click', (e) => {
    const target = e.target;
    const productCard = target.closest('.product-card');
    if (productCard) {

        // Handle Quick Add Click
        if (target.getAttribute('data-quick-add') != null) {
            const quickAdd = productCard.querySelector('[data-quick-add]');
            const productCardForm = productCard.querySelector('form.product-form.product-card-form');
            const productCardJSONScript = productCard.querySelector('script[data-product-json]');
            // console.log('🚀 Clicked Quick Add...', target, ' | productForm: ', productCardForm, " | productCardJSONScript", productCardJSONScript);

            if (productCardForm) {

                productCardForm.classList.add('modal-open');

                if (productCardJSONScript) {
                    const productCardJSON = JSON.parse(productCardJSONScript.innerHTML);

                    if (productCardForm && productCardJSON && productCard.getAttribute('quick-add-initialised') == null) {
                        // console.log('🚀🚀🚀 Initialising Product Card Form...');
                        new window.ProductForm(productCardForm, productCardJSON);

                        // Add attribute to ensure intialisation once
                        productCard.setAttribute('quick-add-initialised', '');
                    } else {
                        // console.log('🚀🚀🚀 Product Card ALREADY Initialised...', productCard);
                    }
                }

            }

        } else if (target.getAttribute('data-close-quick-add') !== null) {
            e.preventDefault();
            const productCardForm = productCard.querySelector('form.product-form.product-card-form');

            if (productCardForm) productCardForm.classList.remove('modal-open');

        }


    }
})
